import Vue from "vue";

export const EventBus = new Vue({});
export const EventBusManagement = {
  listeners: {},
  on(event, callback) {
    // console.log(this.listeners);

    // Stellt sicher, dass der Listener-Container für das Event existiert
    if (!this.listeners[event]) {
      this.listeners[event] = new Set();
    } else {
      // Entfernt alle vorherigen Listener für dieses Event,
      // um Doppelregistrierungen zu vermeiden
      this.listeners[event].forEach((existingCallback) => {
        EventBus.$off(event, existingCallback);
      });
      this.listeners[event].clear();
    }

    // Registriert den neuen Listener
    EventBus.$on(event, callback);
    this.listeners[event].add(callback);
  },
  off(event, callback) {
    EventBus.$off(event, callback);
    if (this.listeners[event]) {
      this.listeners[event].delete(callback);
      if (this.listeners[event].size === 0) {
        delete this.listeners[event];
      }
    }
  },
  clear(event) {
    if (this.listeners[event]) {
      this.listeners[event].forEach((callback) => {
        EventBus.$off(event, callback);
      });
      delete this.listeners[event];
    }
  },
  listEvents() {
    return Object.keys(this.listeners);
  },
  listListeners(event) {
    return this.listeners[event] ? Array.from(this.listeners[event]) : [];
  }
};

EventBus.$on("gotoStep", (step = 1) => {
  window.scrollTo({ top: 0, behavior: "auto" });

  // Umwandlung des Schritts in eine Zeichenkette, falls er als Zahl übergeben wird,
  // und sicherstellen, dass der Vergleich konsistent ist.
  const targetStep = String(step);

  // Aktuelle Route und Abfrageparameter prüfen.
  const currentPath = router.currentRoute.path;
  const currentStep = router.currentRoute.query.step;

  // Nur navigieren, wenn der neue Schritt anders ist als der aktuelle.
  if (targetStep !== "" && currentStep !== targetStep) {
    router.push({ path: currentPath, query: { step: targetStep } })
      .catch(err => {
        // Ignoriert die Fehlermeldung bei redundanter Navigation,
        // behandelt aber alle anderen Fehler normal.
        if (err.name !== "NavigationDuplicated") {
          // Loggen oder behandeln anderer Fehler nach Bedarf.
          console.error(err);
        }
      });
  }
});

EventBus.$on("show-snackbar", function({
                                         message,
                                         type = "is-dark",
                                         queue = false,
                                         duration = 4000,
                                         position = "is-bottom",
                                         indefinite = false
                                       }) {
  this.$buefy.toast.open({
    message: message,
    type: type,
    duration: duration,
    queue: queue,
    position: position,
    indefinite: indefinite
  });
});
